import { NavigationList } from "@/features/navigation/components/navigation-list";

function SocietyNavigationPage() {
  return <NavigationList />;
}

export { SocietyNavigationPage };
